import { render } from "./HouseView.vue?vue&type=template&id=42ce7560"
import script from "./HouseView.vue?vue&type=script&lang=js"
export * from "./HouseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__